const DEFAULT_MARGIN = 8
const DEFAULT_MAX_W = 500
const VERTICAL_GAP = 6

export type FilterPanelRect = { top: number; left: number; width: number }

type TriggerBox = Pick<DOMRect, 'left' | 'right' | 'top' | 'bottom' | 'width'>

/**
 * Places the filter panel so it grows away from the nearest viewport edge:
 * trigger in the left half → panel's left aligns with the trigger (opens rightward);
 * trigger in the right half → panel's right aligns with the trigger (opens leftward).
 * Result is clamped to the viewport.
 */
export function computeFilterPanelRect(
  trigger: TriggerBox,
  viewportWidth: number,
  options?: { margin?: number; maxWidth?: number }
): FilterPanelRect {
  const margin = options?.margin ?? DEFAULT_MARGIN
  const maxW = options?.maxWidth ?? DEFAULT_MAX_W
  const w = Math.min(maxW, Math.max(0, viewportWidth - 2 * margin))
  const triggerMidX = trigger.left + trigger.width / 2
  const viewportMid = viewportWidth / 2

  let left =
    triggerMidX < viewportMid ? trigger.left : trigger.right - w

  const maxLeft = viewportWidth - w - margin
  left = Math.min(Math.max(left, margin), maxLeft)

  return { top: trigger.bottom + VERTICAL_GAP, left, width: w }
}
